var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "item-selector" },
    [
      _c("sw-select", {
        ref: "baseSelect",
        staticClass: "multi-select-item",
        attrs: {
          options: _vm.estimates,
          "show-labels": false,
          "preserve-search": false,
          placeholder: _vm.$t("customers.type_or_click"),
          label: "estimate_number",
        },
        on: {
          close: _vm.checkEstimates,
          value: _vm.onTextChange,
          select: (val) => _vm.$emit("select", val),
          remove: _vm.deselectEstimate,
        },
        model: {
          value: _vm.estimateSelect,
          callback: function ($$v) {
            _vm.estimateSelect = $$v
          },
          expression: "estimateSelect",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }